import React, { useState, useEffect } from 'react';
import { Gift, Calendar, Clock } from 'lucide-react';
import BookingModal from './BookingModal';
import Loader from './Loader';
import { optimizeImageUrl } from '@/lib/imageUtils';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const EarlyBirdDeals = () => {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const [selectedDeal, setSelectedDeal] = useState({ title: '', destination: '' });
  const [earlyBirdDeals, setEarlyBirdDeals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/early-bird-deals`)
      .then(res => res.json())
      .then(data => {
        setEarlyBirdDeals(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching early bird deals:', err);
        setLoading(false);
      });
  }, []);

  const handleBookNow = (deal) => {
    setSelectedDeal({ title: deal.title, destination: deal.destination });
    setIsBookingModalOpen(true);
  };

  if (loading) {
    return (
      <section id="tours" className="early-bird-section">
        <div className="section-header">
          <Gift className="section-icon" />
          <h2 className="section-title">Early Bird Discounts – Book & Save</h2>
          <p className="section-subtitle">Plan ahead and save thousands on your dream vacation</p>
        </div>
        <Loader />
      </section>
    );
  }

  return (
    <section id="tours" className="early-bird-section">
      <div className="section-header">
        <Gift className="section-icon" />
        <h2 className="section-title">Early Bird Discounts – Book & Save</h2>
        <p className="section-subtitle">Plan ahead and save thousands on your dream vacation</p>
      </div>

      <div className="early-bird-grid">
        {earlyBirdDeals.map((deal) => (
          <div key={deal.id} className="early-bird-card">
            <div className="early-bird-image-wrapper">
              <img
                src={optimizeImageUrl(deal.image, 600)}
                alt={deal.destination}
                className="early-bird-image"
                loading="lazy"
                decoding="async"
              />
              <div className="early-bird-badge">
                <Clock size={16} />
                Valid Till: {deal.validTill}
              </div>
            </div>

            <div className="early-bird-content">
              <div className="destination-tag">{deal.destination}</div>
              <h3 className="early-bird-title">{deal.title}</h3>

              <div className="travel-period">
                <Calendar size={16} />
                <span>Travel: {deal.travelPeriod}</span>
              </div>

              <p className="early-bird-includes">{deal.includes}</p>

              <div className="early-bird-pricing-only">
                <div className="price-info">
                  <span className="original-price">{deal.originalPrice}</span>
                  <span className="current-price">{deal.price}</span>
                  <span className="discount-text">{deal.discount}</span>
                </div>
              </div>

              <button 
                onClick={() => handleBookNow(deal)}
                className="book-now-btn"
                data-testid={`book-now-early-${deal.id}`}
              >
                Book Now
              </button>
            </div>
          </div>
        ))}
      </div>

      <BookingModal 
        isOpen={isBookingModalOpen}
        onClose={() => setIsBookingModalOpen(false)}
        dealTitle={selectedDeal.title}
        destination={selectedDeal.destination}
      />
    </section>
  );
};

export default EarlyBirdDeals;
